import React from 'react'
import Breadcrum from '../Components/Breadcrum'

import bb1 from '../Images/bblog-1.jpg'
import bb2 from '../Images/bblog-2.jpg'
import bb3 from '../Images/bblog-3.jpg'
import bb4 from '../Images/bblog-4.jpg'
import bb5 from '../Images/bblog-5.jpg'
import bb6 from '../Images/bblog-6.jpg'
import bb7 from '../Images/bblog-7.jpg'
import bb8 from '../Images/bblog-8.jpg'
import bb9 from '../Images/bblog-9.jpg'

const Blog = () => {
  return (
    <div>
      
      <Breadcrum pageName={'Blog'}/>

      <section className="blog spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb1} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>Trend news</span>
                  </div>
                  <h4>
                    <a href="#">
                      8 Romantic Gifts to Celebrate Your Wedding Anniversary
                    </a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb2} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>Tips &amp; Idea</span>
                  </div>
                  <h4>
                    <a href="#">Red Rose - Flower of love of Greek Mythology</a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb3} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>DIY &amp; Crafts</span>
                  </div>
                  <h4>
                    <a href="#">
                      Beautiful Mandalas Made From Flowers by Kathy Klein
                    </a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb4} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>Trend News</span>
                  </div>
                  <h4>
                    <a href="#">6 Unique Features of the Floret Online Workshop</a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb5} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>Tips &amp; Idea</span>
                  </div>
                  <h4>
                    <a href="#">Beyond Red Roses: Valentine’s Day Gift Guide</a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb6} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>DIY &amp; Crafts</span>
                  </div>
                  <h4>
                    <a href="#">
                      A Year in Flowers Makes the New York Times Bestseller List
                    </a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb7} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>Trend News</span>
                  </div>
                  <h4>
                    <a href="#">Launching A Year in Flowersinto the World</a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb8} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>Tips &amp; Idea</span>
                  </div>
                  <h4>
                    <a href="#">Beyond Red Roses: Valentine’s Day Gift Guide</a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog__item">
                <div className="blog__item__pic">
                  <img src={bb9} alt="" />
                </div>
                <div className="blog__item__text">
                  <div className="label">
                    <span>DIY &amp; Crafts</span>
                  </div>
                  <h4>
                    <a href="#">Pansies and Violas for Cut Flowers</a>
                  </h4>
                  <p>
                    Flowers have a language all their own. In Victorian times,
                    receiving a…
                  </p>
                  <span>MAY 22, 2020</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="view__all">
                <a href="#">View all posts</a>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default Blog